import { twJoin } from 'tailwind-merge';

import type { Props as BaseButtonProps } from './BaseButton';
import { BaseButton } from './BaseButton';

export const MapButton = ({ className, ...rest }: BaseButtonProps) => {
  return (
    <BaseButton
      {...rest}
      className={twJoin('bg-white rounded-full text-gray-900 w-11 h-11 min-w-0 shadow-lg', className)}
    />
  );
};
